import styled from "styled-components";
import theme from "../../styles/theme";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ClickableIcon } from "../../components/Icon";
import Modal from "../../components/Modal";
import Input from "../../components/Input";
import { useState } from "react";

type GetPrefixModal = {
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  confirmFunction: (prefix:string) => void;
  title: string;
  description: string;
};
const Title = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
`;
const Flex = styled(FlexGrow)`
  padding: 24px;
  width: 318px;
  background: rgba(197, 207, 236, 0.1);
  border-radius: 4px;
  margin: 24px 10px;
`;
const Desc = styled.p`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */
  padding: 16px 0;
  display: flex;
  align-items: center;
  text-align: center;
  margin: 0px 10px;
`;

const GetPrefixModal = ({
  isOpen,
  setOpen,
  confirmFunction,
  title,
  description,
}: GetPrefixModal): JSX.Element => {
  const [prefix, setPillars] = useState<string>("");
  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: { zIndex: "999999" },
          content: { maxWidth: "366px", padding: "0 16px 24px 16px" },
        }}
      >
        {/* <FlexBox style={{ height: "64px", borderBottom: "1px solid #dbdbdb" }}>
          <FlexGrow>
            <Title>{title}</Title>
          </FlexGrow>
          <ClickableIcon
            name="close"
            color="white"
            onClick={() => setOpen(false)}
          />
        </FlexBox> */}
        <FlexBox>
          <Flex>
            {description}
            <FlexGrow>
              <Input
                style={{ width: "100%", marginTop: "16px" }}
                onChange={(event:any) => setPillars(event.target.value)}
                isFullWidth
                autoFocus
              />
            </FlexGrow>
          </Flex>
        </FlexBox>
        <FlexBox justify="center">
          <FlexGrow style={{ flexGrow: "0" }}>
            <Button
              className="reduce_opct_onhover"
              style={{
                width: "151px",
                height: "48px",
                padding: "13px 12px",
                border: "2px solid rgb(203, 213, 225)",
                // color: "gray"
                // backgroundColor: '#c75151'
              }}
              isOutline
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancel
            </Button>
          </FlexGrow>
          <FlexGrow style={{ flexGrow: "0" }}>
            <Button
              className="reduce_opct_onhover"
              disabled={!prefix}
              style={{
                width: "151px",
                height: "48px",
                padding: "13px 12px",
                color: "white",
                background: theme.color.blueButton,
                boxShadow: "0 2px 5px gray",
                border: "none",
              }}
              type="button"
              onClick={() => {
                confirmFunction(prefix);
              }}
            >
              Continue
            </Button>
          </FlexGrow>
        </FlexBox>
      </Modal>
    </>
  );
};

export default GetPrefixModal;
